<template lang='pug'>
pdfViewer(:pdfUrl='pdfUrl' showDownload showShare @download="download")
</template>

<script>
import pdfViewer from '@custouch/pdf-viewer'
import { getDataRow, concatWithSymbol, getSubmitCounts } from '@custouch/proxy-use'
export default {
    name:'pdfView',
    components:{
        pdfViewer
    },
    props:{
        hId: String,
        rId: String
    },
    data(){
        return {
            pdfUrl:''
        }
    },
    async created() {
        const data = await getDataRow({dataRowId: this.rId})
        // const [data,{ path }] = await Promise.all([getDataRow({dataRowId: this.rId}),getRowPath(this.rId,this.$route.meta.mId,this.hId)])
        let name = data.detail.pdfName
        let pdfLink = data.detail.pdfLink
        this.$root.$emit('pageview',{title:concatWithSymbol([this.$route.meta.title,name]),tagIds: data.tagIds.join(',')})
        this.$root.$emit('updateShare',{title:name+'-'+document.title})
        this.$root.$emit('action',{name:this.$route.name,a:name})
        let link = pdfLink.replace(/\/pdfviewer/, '')
        this.pdfUrl=await this.$store.dispatch('getSignatureUrl',link)
        // this.$root.$emit('updateShare',{title:this.$route.query.name+'-'+document.title})
        //  this.$root.$emit('action',{name:this.$route.name,a:this.$route.query.name})
        //  this.pdfUrl=await this.$store.dispatch('getSignatureUrl',this.$route.query.link)
    },
    methods:{
        async download(){
            const { VUE_APP_MEMBER_FORMID, VUE_APP_FORM } = window.env
            const res = await getSubmitCounts([VUE_APP_MEMBER_FORMID])
            const count = Number(
                (res?.data || []).find(item => item.formId === VUE_APP_MEMBER_FORMID)?.count || 0
            )
            if (!count) {
                window.location.href = `${VUE_APP_FORM}${VUE_APP_MEMBER_FORMID}?c_default_redirect=${encodeURIComponent(window.location.href)}`
                return
            }
            window.location.href = this.pdfUrl
        }
    }
}
</script>

<style scoped lang='less'>

</style>